import {Component, EventEmitter, Output} from '@angular/core';

import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'surveym-rating',
  templateUrl: './rating.component.html',
})
export class RatingComponent {

  @Output() ratingChanged = new EventEmitter<number>();

  readonly ratingDescriptions: string[] = [];
  hoverdIndex = 0;

  private rating = 0;

  constructor(private translateService: TranslateService) {
    this.fillRatingDescriptions();
  }

  onStarSelected(starIndex: number) {
    this.rating = starIndex;
    this.ratingChanged.emit(starIndex);
  }

  onHoverd(starIndex: number, isHoverd: boolean) {
    this.hoverdIndex = isHoverd ? starIndex : 0;
  }

  isStarSelected(starIndex: number) {
    return this.rating >= starIndex;
  }

  isStarHoverd(starIndex: number) {
    return this.hoverdIndex >= starIndex;
  }

  private fillRatingDescriptions() {
    this.translateService.get([
      'survey.star-label-poor',
      'survey.star-label-awesome'])
      .subscribe(t =>  {
        Object.entries<string>(t).forEach((x) => this.ratingDescriptions.push(x[1]));
        this.ratingDescriptions.splice(1,0, ''); //dodanie pustych podpisów pod gwiazdkami
        this.ratingDescriptions.splice(2,0, '');
        this.ratingDescriptions.splice(3,0, '');
      });
  }

}
